import {APP_INITIALIZER, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
//Core module
import { CoreModule } from './core/core.module';
// Material Form Controls
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
// Material Navigation
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
// Material Layout
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatListModule } from '@angular/material/list';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTreeModule } from '@angular/material/tree';
// Material Buttons & Indicators
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatBadgeModule } from '@angular/material/badge';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MAT_DATE_LOCALE, MatRippleModule } from '@angular/material/core';
// Material Popups & Modals
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
// Material Data tables
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { initializeKeycloak } from './config/keycloak.config';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { UuidInterceptor } from './core/interceptors/uuid.interceptor';
// Keycloak
import {KeycloakAngularModule, KeycloakBearerInterceptor, KeycloakService} from "keycloak-angular";
import { SurveyFormModule } from './pages/survey/survey-form/survey-form.module';
import { PsaModule } from './pages/psa/psa.module';
//Spinner
import { SpinnerComponent } from './shared/components/ui-components/spinner/spinner.component';
import { Ability, PureAbility } from '@casl/ability';
import { DashboardModule } from './pages/dashboard/dashboard.module';

import { TestApiModule } from './pages/test-api/test-api.module';
import { NotificationFluxService } from './layouts/full/vertical/header/notification-flux.service';
import { provideQueryService } from './core/services/query.service';
import { NOTIFICATION_ENDPOINT, notificationStateConfig } from './layouts/full/vertical/header/notification.config';
import { NotificheModule } from './pages/notifiche/notifiche.module';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { FiliereModule } from './pages/anagrafica-filiere/filiere.module';



@NgModule({
  declarations: [],
  imports:[
    CoreModule,
    SpinnerComponent,
    KeycloakAngularModule
  ],
  exports: [
    MatAutocompleteModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatSidenavModule,
    MatToolbarModule,
    MatCardModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatListModule,
    MatStepperModule,
    MatTabsModule,
    MatTreeModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatBadgeModule,
    MatChipsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatRippleModule,
    MatBottomSheetModule,
    MatDialogModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    SurveyFormModule,
    PsaModule,
    TestApiModule,
    DashboardModule,
    NotificheModule,
    FiliereModule,
    SpinnerComponent,
  ],
  providers: [
   
  /*   {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService]
    }, */

    KeycloakService,
    {provide: MAT_DATE_LOCALE, useValue: 'it-IT'},
        {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UuidInterceptor,
      multi: true
    },
/*     {
      provide: HTTP_INTERCEPTORS,
      useClass: KeycloakBearerInterceptor,
      multi: true
    }, */

    { provide: Ability, useValue: new Ability() },
    { provide: PureAbility, useExisting: Ability },
    ...provideQueryService<any>(NOTIFICATION_ENDPOINT, notificationStateConfig),
    NotificationFluxService
  ],

})
export class MaterialModule {}
